/* eslint-disable */
// @ts-nocheck

import { defineStore } from "pinia";

import {
  QuoteLineItemFieldsFragment as QuoteLineItemType,
} from "gql/api";

import {
  spyglassTypes,
  SpyglassType
} from "@/components/quotes/types";

type LineItemStoreState = {
  selectedDescription: string | null;
  selectedQuoteLineItem: QuoteLineItemType | null;
};

export const useLineItemStore = defineStore({
  id: "lineItemStore",
  state: () =>
    ({
      selectedDescription: null,
      selectedQuoteLineItem: null,
    }) as LineItemStoreState,
  getters: {
    getSelectedDescription(): string | null {
      return this.selectedDescription;
    },
    isSelectedQliFromScenario(): bool {
      if (!this.selectedQuoteLineItem) {
        return false;
      }

      // A material number indicates the spyglass equipment was replaced.
      // If it exists, it leaves the classification of being "spyglass equipment".
      return (
        !!this.selectedQuoteLineItem
        && !this.selectedQuoteLineItem?.erp_material_number
        && spyglassTypes.some((type) =>
          this.selectedQuoteLineItem.hasOwnProperty(type) && this.selectedQuoteLineItem[type]
        )
      )
    },
    isValidSpyglassEquipment(): bool {
      // Getters can be accessed from actions, but getters cannot access actions.
      const equipment_is_not_replaced = this.isSelectedQliFromScenario;

      return (
        this.getSpyglassEquipmentId()
        && this.getSpyglassEquipmentString()
        && equipment_is_not_replaced
      )
    },
  },
  actions: {
    addSelectedDescription(desc): string {
      this.selectedDescription = desc;
    },
    removeSelectedDescription(idx): string {
      const oldDesc = this.selectedDescription;

      this.selectedDescription = null;
      return oldDesc;
    },
    addSelectedQuoteLineItem(qli: QuoteLineItemType): null {
      this.selectedQuoteLineItem = Object.assign({}, qli);
    },
    removeSelectedQuoteLineItem(qli: QuoteLineItemType): null {
      this.selectedQuoteLineItem = null;
    },
    getSpyglassEquipmentId(): string {
      if (!this.selectedQuoteLineItem) {
        return '';
      }

      // TODO Look into using the equipment json as a fallback
      // TODO spyglass_equipment_import_json.r_housing.pump_id
      // TODO spyglass_equipment_import_json.r_housing.intake_id
      // TODO spyglass_equipment_import_json.r_housing.cable_id
      const equipment = spyglassTypes
        .map((type) => this.selectedQuoteLineItem[type])
        .find((fieldValue) => fieldValue && fieldValue.id);

      return equipment?.id || '';
    },
    getSpyglassEquipmentString(): SpyglassType {
      if (!this.selectedQuoteLineItem) {
        return ''
      }

      let equipmentTypeString = spyglassTypes.find((type) => {
        return (
          Object.keys(this.selectedQuoteLineItem).includes(type) &&
          this.selectedQuoteLineItem[type]
        )
      });

      if (!equipmentTypeString) {
        // use line item type fallback: no equipment but user categorized it
        equipmentTypeString = this.selectedQuoteLineItem?.line_item_type || '';
      }

      return equipmentTypeString || '';
    },
  }
});
